var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sidebar" },
    [
      _c(
        "el-menu",
        {
          staticClass: "sidebar-el-menu",
          attrs: {
            collapse: _vm.collapse,
            "background-color": "transparent",
            "default-active": _vm.$route.path,
            "text-color": "#464646",
            "active-text-color": "#fff",
            "active-background-color": "#f8ab01",
            "unique-opened": "",
            router: "",
            mode: "vertical",
          },
        },
        [
          _vm._l(_vm.items, function (item) {
            return [
              item.subs
                ? [
                    _c(
                      "el-submenu",
                      { key: item.index, attrs: { index: item.index } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("i", { class: "icon-" + item.icon }),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t(item.title)))]
                          ),
                        ]),
                        _vm._l(item.subs, function (subItem) {
                          return [
                            subItem.subs
                              ? _c(
                                  "el-submenu",
                                  {
                                    key: subItem.index,
                                    staticClass: "secondary_main_menu",
                                    attrs: { index: subItem.index },
                                  },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(_vm._s(_vm.$t(subItem.title))),
                                    ]),
                                    _vm._l(
                                      subItem.subs,
                                      function (threeItem, i) {
                                        return _c(
                                          "el-menu-item",
                                          {
                                            key: i,
                                            staticClass: "secondary_submenu",
                                            attrs: { index: threeItem.index },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(threeItem.title)
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c(
                                  "el-menu-item",
                                  {
                                    key: subItem.index,
                                    attrs: { index: subItem.index },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resolvePath($event, subItem)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t(subItem.title)) + " "
                                    ),
                                  ]
                                ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                : [
                    _c(
                      "el-menu-item",
                      { key: item.index, attrs: { index: item.index } },
                      [
                        _c("i", { class: "icon-" + item.icon }),
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_vm._v(_vm._s(_vm.$t(item.title)))]
                        ),
                      ]
                    ),
                  ],
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }